import { defineComponent as _defineComponent } from 'vue'
import ContactUsForm from "./ContactUsForm.vue";
  import ContactUsLink from "./ContactUsLink.vue";
  import { computed, watch } from "vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { CALENDLY_DEMO_LINK } from "@/constants/calendlyLinks";

  const IS_DESKTOP_BREAK_POINT = 990;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandingFooter',
  props: {
    showBanner: {
      type: Boolean,
      default: true,
    },
    showContactUsForm: {
      type: Boolean,
      default: true,
    },
    isPlansView: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(IS_DESKTOP_BREAK_POINT);
  const props = __props;
  const bannerButtonText = computed(() => {
    if (isDesktop.value) {
      return "Get Started";
    }

    return "Partner with us";
  });

const __returned__ = { IS_DESKTOP_BREAK_POINT, isDesktop, props, bannerButtonText, ContactUsForm, ContactUsLink, computed, watch, get useIsDesktop() { return useIsDesktop }, get CALENDLY_DEMO_LINK() { return CALENDLY_DEMO_LINK } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})